export default "__VITE_ASSET__CohYLzlY__"